module.exports = __webpack_public_path__ + "static/media/gc-chapter-1.bb8dd2ce.png";